export const en_Us = {
  INFO_FILTER_HEADER: "Filtre as solicitações por fazenda(s)",
  INFO_REQUEST_HEADER: "Acompanhe suas solicitações",
};
